document.addEventListener("DOMContentLoaded", () => {
  const modal = document.getElementById("ingredients-side-modal");

  const ingredientModalTitle = modal.querySelector('.ingredients-side-modal-title');
  const ingredientImage = modal.querySelector('.ingredients-modal-body-image img');
  const ingredientTitle = modal.querySelector('.ingredients-modal-body-title');
  const ingredientDescription = modal.querySelector('.ingredients-modal-body-description');

  const openTriggers = document.querySelectorAll(".ingredients-item");
  const closeBtn = modal.querySelector(".close-ingredients-modal");
  const overlay = modal.querySelector(".ingredients-side-modal-overlay");

  const prevIngredient = document.querySelector('.ingredients-modal-navigation-left');
  const nextIngredient = document.querySelector('.ingredients-modal-navigation-right');

  const currentSlide = document.querySelector('.ingredients-modal-navigation-slider');
  const totalSlides = document.querySelector('.ingredients-modal-navigation-total');

  totalSlides.textContent = openTriggers.length;

  let ingredientIndex;

  prevIngredient.addEventListener('click', function () {
    if (ingredientIndex === 0) {
      ingredientIndex = openTriggers.length - 1;
    } else {
      ingredientIndex -= 1;
    }

    updateModalContent(openTriggers[ingredientIndex]);
  });

  nextIngredient.addEventListener('click', function () {
    if (ingredientIndex === openTriggers.length - 1) {
      ingredientIndex = 0;
    } else {
      ingredientIndex += 1;
    }

    updateModalContent(openTriggers[ingredientIndex]);
  });

  function updateModalContent (ingredient) {
    const img = ingredient.querySelector('.ingredients-item-image img');
    const title = ingredient.querySelector('.ingredients-item-title');
    const modalTitle = ingredient.querySelector('.ingredients-item-modal-title');
    const description = ingredient.querySelector('.ingredients-item-description');

    ingredientModalTitle.textContent = modalTitle.textContent;
    ingredientImage.src = img.src;
    ingredientTitle.textContent = title.textContent;
    ingredientDescription.textContent = description.textContent;

    currentSlide.textContent = ingredientIndex + 1;
  }

  function openModal(card) {
    modal.classList.remove("hidden");
    requestAnimationFrame(() => {
      modal.classList.add("show");
    });
    document.body.style.overflow = 'hidden';

    updateModalContent(card);
  }

  function closeModal() {
    modal.classList.remove("show");
    modal.addEventListener("transitionend", () => {
      modal.classList.add("hidden");
    }, { once: true });
    document.body.style.overflow = '';
  }

  openTriggers.forEach(function (openTrigger) {
    openTrigger.addEventListener("click", function (e) {
      const card = e.currentTarget;

      ingredientIndex = [...openTriggers].findIndex(trigger => trigger === card);

      openModal(card);
    });
  })

  closeBtn.addEventListener("click", closeModal);
  overlay.addEventListener("click", closeModal);
});
